import React from 'react'
import { SectionHeader } from 'src/components/framework/ui/section-header'
import { RatioGraph } from 'src/components/page/ratios/ratio-graph'

export const ShareholderActivity: React.FC = () => {
  return (
    <>
      <SectionHeader>Shareholder Activity</SectionHeader>
      <table className={'stk-table-stretched stk-space-out-t-0'}>
        <thead>
          <tr>
            <th style={{ width: '1%' }}>
              <span className="visually-hidden">Type</span>
            </th>
            <th className={'stk-text-align-c'}>Buy / Hold / Sell</th>
          </tr>
        </thead>
        <tbody>
          {LABELS.map((item, index) => (
            <tr key={index}>
              <td>{item}</td>
              <td>
                <RatioGraph percentile={0} locked={true} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

const LABELS: ReadonlyArray<string> = ['Institutions', 'Directors', 'Community']
